/////////////////////////////////////////////////////////////////////
// public/general functions, parameter and constants
/////////////////////////////////////////////////////////////////////

// define standard text that has to be localized within javascript
// index 0 = standard language (deutsch)
// index 1 = french
var generalText = new Array();
generalText[0] = new Array();
generalText[1] = new Array();
generalText[0]['start-task'] = "Aufgabe wird geladen";
generalText[1]['start-task'] = "La tâche est en cours de chargement";
generalText[0]['videoscrubbing-text'] = "Mit Maus oder Pfeiltasten scrubben";
generalText[1]['videoscrubbing-text'] = "Avancer/reculer à l'aide de la souris";

generalText[0]['task-upload-file-placeholder'] = "Neue Datei hochladen";
generalText[1]['task-upload-file-placeholder'] = "Télécharger nouvelles données";
generalText[0]['task-upload-file-button'] = "Datei wählen";
generalText[1]['task-upload-file-button'] = "Sélectionner les données";
generalText[0]['task-upload-file'] = "Vorhanden: ";
generalText[1]['task-upload-file'] = "Existant: ";
generalText[0]['task-validation-loadertext'] = "Aufgabe wird gespeichert.<br>Dies kann mehrere Minuten dauern.";
generalText[1]['task-validation-loadertext'] = "La tâche est sauvée.<br>Cela peut prendre plusieurs minutes.";

generalText[0]['hover-task'] = "Aufgabe:";
generalText[1]['hover-task'] = "Tâche:";
generalText[0]['hover-competence-area'] = "Kompetenzbereich:";
generalText[1]['hover-competence-area'] = "Domaine de compétence:";
generalText[0]['hover-qualitiydimension'] = "Qualitätsdimension:";
generalText[1]['hover-qualitiydimension'] = "Composante de qualité:";

generalText[0]['action-preview'] = "Voransicht";
generalText[1]['action-preview'] = "Aperçu";
generalText[0]['action-remove'] = "Entfernen";
generalText[1]['action-remove'] = "Supprimer";

generalText[0]['learningbio-d3-label-task'] = "Aufgaben: ";
generalText[1]['learningbio-d3-label-task'] = "Tâches: ";
generalText[0]['learningbio-d3-label-result'] = "Resultat: ";
generalText[1]['learningbio-d3-label-result'] = "Résultat: ";
generalText[0]['learningbio-d3-task-single'] = " Aufgabe gelöst";
generalText[1]['learningbio-d3-task-single'] = " Tâche résolu";
generalText[0]['learningbio-d3-task-multiple'] = " Aufgaben gelöst";
generalText[1]['learningbio-d3-task-multiple'] = " Tâches résolu";
generalText[0]['learningbio-d3-task-success'] = " % erfolgreich";
generalText[1]['learningbio-d3-task-success'] = " (fr) % de réussite";

generalText[0]['start-exam'] = "Prüfungen werden bereit gestellt";
generalText[1]['start-exam'] = "Les examens sont créés";


	$(document).ready(function(){

	//toggle competence areas: start page and learningbio
	$('.tasktype-selection.tasklist-header').bind('click',function(e) {
		e.preventDefault();
		let tasklistSection = $(this).data('tasklist');
		if (!$(this).hasClass('active')) {
			$('.tasktype-selection.tasklist-header.active').removeClass('active');
			$(this).addClass('active');

			$('.tasklist-container.active').removeClass('active');
			$('.tasklist-container[data-tasklist="'+tasklistSection+'"]').addClass('active');

			// resizing the select
			$('.sbHolder').each(function() {
				var sbSelector = $(this).find('.sbSelector');
				$(this).width(sbSelector.outerWidth(true)+40);
			});
		}
	});

	//toggle competence areas in offcanvas menu
	$('.tasktype-selection.tasklist-header-offcanvas').bind('click',function(e) {
		e.preventDefault();

		let tasklistSection = $(this).data('tasklist-offcanvas');
		if (!$(this).hasClass('active')) {
			$('.tasktype-selection.tasklist-header-offcanvas.active').removeClass('active');
			$(this).addClass('active');

			$('.tasklist-container-offcanvas.active').removeClass('active');
			$('.tasklist-container-offcanvas[data-tasklist-offcanvas="'+tasklistSection+'"]').addClass('active');
		}
	});

	//enable deeplinking of competence areas on root page
	setTimeout(function () {
		if(location.hash){
			let deeplink = location.hash.split('#')[1];
			let hashLink = $('.tasktype-selection.tasklist-header.categoryTaskList[data-deeplink="'+deeplink+'"]');
			let hashContent = $('.tasklist-container[data-deeplink="'+deeplink+'"]');

			$('.tasktype-selection.tasklist-header.categoryTaskList').removeClass('active');
			$('.tasklist-container').removeClass('active');
			if(!$(hashLink).hasClass('active')) {
				hashLink.toggleClass('active');
				hashContent.toggleClass('active');

				// resizing the select
				$('.sbHolder').each(function() {
					var sbSelector = $(this).find('.sbSelector');
					$(this).width(sbSelector.outerWidth(true)+40);
				});
			}
		}
	}, 500);

});


